import { classMap as t } from "lit/directives/class-map.js";
import { html as o } from "lit/static-html.js";
const e = (i) => {
  const s = {
    "dss-tooltip": !0,
    [`dss-tooltip--${i.position}`]: !!i.position,
    [`dss-tooltip--align-${i.align}`]: !!i.align,
    "dss-tooltip--hidden": i.hide,
    "dss-tooltip--no-height-limit": i.noHeightLimit
  };
  return o`
    <div 
			role="tooltip"
			class="${t(s)}"
			@mouseenter="${i._onMouseEnter}"
			@mouseleave="${i._onMouseLeave}"
			aria-hidden="${i.ariaHidden || "false"}"
		>
      <slot></slot>
    </div>
  `;
};
export {
  e as template
};
//# sourceMappingURL=tooltip.template.js.map
